import { LEGACY_COURSES } from '../portal/course-legacy.mjs'

// 과정 메뉴(레거시 /lecture/?sort01=&sort02=)와 강좌 분류의 대응. 대분류 메뉴는 하위 분류 강좌를 모두 보인다.
// 오프라인교육(lecture02)은 레거시와 같이 집체 과정 목록·상세를 보이고, 신청은 신청 안내 창(CourseApplyDialog)에서 받는다.
export const COURSE_CATEGORY_PATHS = {
  '/course/legal': 'lecture01', '/course/legal/common': 'lecture0101', '/course/legal/job': 'lecture0102',
  '/course/safety': 'lecture03', '/course/safety/worker': 'lecture0301', '/course/safety/supervisor': 'lecture0302',
  '/course/offline': 'lecture02', '/course/offline/chatgpt': 'lecture0207', '/course/offline/dx': 'lecture0211', '/course/offline/bigdata': 'lecture0202',
  '/course/offline/digital-twin': 'lecture0203', '/course/offline/esg': 'lecture0204', '/course/offline/jmp': 'lecture0205', '/course/offline/manufacturing-ai': 'lecture0206',
  '/course/offline/robot': 'lecture0208', '/course/offline/safety': 'lecture0209', '/course/offline/mold': 'lecture0210',
  '/course/job': 'lecture04', '/course/job/manufacturing': 'lecture0401', '/course/job/it': 'lecture0402', '/course/job/competency': 'lecture0405', '/course/job/certificate': 'lecture0403', '/course/job/language': 'lecture0404',
}
export const COURSE_PATHS = Object.keys(COURSE_CATEGORY_PATHS)
/** 강좌 분류로 과정 안내 메뉴 경로를 찾는다(분류 메뉴가 없으면 상위 분류 메뉴). 내 강의실의 '교육과정 상세보기'가 쓴다. */
export function coursePathOf(categoryId, parentCategoryId) {
  const entries = Object.entries(COURSE_CATEGORY_PATHS)
  return entries.find(([, id]) => id === categoryId)?.[0] || entries.find(([, id]) => id === parentCategoryId)?.[0] || null
}
// 레거시 목록은 10건씩, 산업안전교육(lecture03)만 카드에 교육비를 보였다.
export const COURSE_PAGE_SIZE = 10
const FEE_GROUPS = new Set(['lecture03'])
const LOAD_SIZE = 100, LOAD_PAGES = 10
const CONDITIONS = new Set(['PROGRESS', 'MID_SCORE', 'EXAM_SCORE', 'ASSIGNMENT_SCORE', 'TOTAL_SCORE', 'SURVEY', 'IDENTITY'])
const CODE = /^[A-Z0-9]{6}$/, CATEGORY = /^[A-Za-z0-9_-]{1,100}$/, IMAGE = /^\/api\/public\/courses\/[1-9]\d{0,9}\/image\?v=[0-9a-f]{16}$/
/** 썸네일을 등록하지 않은 강좌·이미지를 읽지 못한 경우의 그림. */
export const NO_IMAGE = '/images/courses/noimage.png'

function text(value, max, optional = true) {
  if (value == null && optional) return ''
  if (typeof value !== 'string' || value.length > max) throw new Error('INVALID_COURSE_RESPONSE')
  return value
}
function count(value) { if (value == null) return null; if (!Number.isSafeInteger(value) || value < 0) throw new Error('INVALID_COURSE_RESPONSE'); return value }
function amount(value) { if (value == null) return null; const number = Number(value); if (!Number.isFinite(number) || number < 0) throw new Error('INVALID_COURSE_RESPONSE'); return number }
function id(value) { if (!Number.isSafeInteger(value) || value < 1) throw new Error('INVALID_COURSE_RESPONSE'); return value }
function code(value) { return typeof value === 'string' && CODE.test(value) ? value : null }
function category(value) {
  if (!value || typeof value !== 'object' || typeof value.categoryId !== 'string' || !CATEGORY.test(value.categoryId)) throw new Error('INVALID_COURSE_RESPONSE')
  return { categoryId: value.categoryId, name: text(value.name, 200, false), parentCategoryId: value.parentCategoryId == null ? null : text(value.parentCategoryId, 100, false) }
}
/** 레거시 표시 값: 정렬 seq, 모바일 학습, 비환급 교육비. 이관하지 않은 새 강좌는 비워 둔다. 썸네일은 강좌에 등록한 이미지(imagePath)다. */
export function legacyDisplay(legacyCode) {
  const row = legacyCode && Object.hasOwn(LEGACY_COURSES, legacyCode) ? LEGACY_COURSES[legacyCode] : null
  return row ? { seq: row[0], mobile: row[1] === 1, fee: row[2] } : { seq: null, mobile: false, fee: null }
}
/** 공개 과정 API가 준 썸네일 주소만 쓴다(같은 출처의 그 강좌 이미지 경로). 그 외 값은 없는 것으로 본다. */
function image(value, courseId) { return typeof value === 'string' && IMAGE.test(value) && value.startsWith(`/api/public/courses/${courseId}/image?`) ? value : null }
function item(value) {
  if (!value || typeof value !== 'object') throw new Error('INVALID_COURSE_RESPONSE')
  const legacyCode = code(value.legacyCode), courseId = id(value.id)
  return { id: courseId, image: image(value.imagePath, courseId), name: text(value.name, 200, false), categoryId: text(value.categoryId, 100, false), categoryName: text(value.categoryName, 200), parentCategoryName: text(value.parentCategoryName, 200),
    lessonCount: count(value.lessonCount), trainingHours: count(value.trainingHours), standardFee: amount(value.standardFee), refund: value.refundCourseAt === 'Y', individualApply: value.individualApplyAt === 'Y', legacyCode, legacy: legacyDisplay(legacyCode) }
}
/** 레거시와 같이 seq 큰 순서. 레거시에 없던 새 강좌는 그 앞에 최근 등록(id 큰) 순으로 둔다. */
export function sortCourses(items) {
  return [...items].sort((a, b) => (a.legacy.seq == null) !== (b.legacy.seq == null) ? (a.legacy.seq == null ? -1 : 1) : a.legacy.seq == null ? b.id - a.id : b.legacy.seq - a.legacy.seq || b.id - a.id)
}
export function filterCourses(items, query) {
  const needle = String(query || '').trim().toLowerCase()
  return needle ? items.filter(row => row.name.toLowerCase().includes(needle)) : items
}
/** 카드 교육비: 환급과정은 표준훈련비, 비환급은 레거시 교육비. 산업안전교육 메뉴만 보인다. */
export function cardFee(row, groupId) {
  if (!FEE_GROUPS.has(groupId)) return null
  const fee = row.standardFee ?? row.legacy.fee
  return fee == null ? null : fee
}
export function won(value) { return `${Math.round(Number(value) || 0).toLocaleString('ko-KR')}원` }
/** 수료 기준 표(레거시 수료기준 및 수강정원). 비활성 조건은 비운다. */
export function completionTable(conditions) {
  const by = Object.fromEntries(conditions.map(row => [row.conditionTy, row]))
  const score = row => row ? { max: row.maxScore, weight: row.weightRate } : null
  return { progress: by.PROGRESS?.thresholdValue ?? null, mid: score(by.MID_SCORE), exam: score(by.EXAM_SCORE), assignment: score(by.ASSIGNMENT_SCORE), total: by.TOTAL_SCORE?.thresholdValue ?? null, survey: Boolean(by.SURVEY), identity: Boolean(by.IDENTITY) }
}
function condition(value) {
  if (!value || !CONDITIONS.has(value.conditionTy)) throw new Error('INVALID_COURSE_RESPONSE')
  return { conditionTy: value.conditionTy, thresholdValue: amount(value.thresholdValue), maxScore: amount(value.maxScore), weightRate: amount(value.weightRate) }
}
export function checkedDetail(value) {
  const base = item(value)
  if (!Array.isArray(value.conditions) || value.conditions.length > 20 || !Array.isArray(value.lessons) || value.lessons.length > 1000) throw new Error('INVALID_COURSE_RESPONSE')
  const fee = value.fee && typeof value.fee === 'object' ? Object.fromEntries(['standardFee', 'priorityAmt', 'priorityBurden', 'under1000Amt', 'under1000Burden', 'over1000Amt', 'over1000Burden'].map(key => [key, amount(value.fee[key])])) : null
  return { ...base, parentCategoryId: value.parentCategoryId == null ? null : text(value.parentCategoryId, 100, false), description: text(value.description, 10000), trainingTarget: text(value.trainingTarget, 10000), trainingGoal: text(value.trainingGoal, 10000),
    contentExpert: text(value.contentExpert, 1000), classCapacity: count(value.classCapacity), fee, conditions: value.conditions.map(condition), lessons: value.lessons.map(name => text(name, 1000, false)) }
}

async function get(path, signal) {
  const response = await fetch(path, { credentials: 'omit', cache: 'no-store', signal: AbortSignal.any([signal, AbortSignal.timeout(10000)]) })
  if (!response.ok) throw Object.assign(new Error('COURSE_UNAVAILABLE'), { status: response.status })
  const body = await response.json(); if (!body?.success || !body.data) throw new Error('COURSE_UNAVAILABLE')
  return body.data
}
/** 메뉴 분류의 공개 강좌를 모두 읽는다(레거시 정렬·검색을 화면에서 하므로). 토큰·쿠키를 보내지 않는다. */
export async function loadCourses(categoryId, signal) {
  if (!CATEGORY.test(categoryId)) throw new Error('INVALID_CATEGORY')
  let items = [], group = null
  for (let page = 1; page <= LOAD_PAGES; page++) {
    const data = await get(`/api/public/courses?${new URLSearchParams({ category: categoryId, page, size: LOAD_SIZE })}`, signal)
    if (!Array.isArray(data.items) || data.items.length > LOAD_SIZE || !Number.isSafeInteger(data.total)) throw new Error('INVALID_COURSE_RESPONSE')
    group ||= category(data.category); if (group.categoryId !== categoryId) throw new Error('INVALID_COURSE_RESPONSE')
    items = items.concat(data.items.map(item))
    if (items.length >= data.total || !data.items.length) break
  }
  return { category: group, items: sortCourses(items) }
}
export async function loadCourse(courseId, signal) {
  if (!/^[1-9]\d{0,9}$/.test(String(courseId))) throw Object.assign(new Error('COURSE_UNAVAILABLE'), { status: 404 })
  const value = checkedDetail(await get(`/api/public/courses/${courseId}`, signal))
  if (value.id !== Number(courseId)) throw new Error('INVALID_COURSE_RESPONSE')
  return value
}
